import { defineComponent as _defineComponent } from 'vue'
import { useModal } from 'vue-nice-modal'
import OrderCouponGift from '../../orderCouponGift/index.vue'
import { PropType, ref } from 'vue'
import type { CouponProps } from '@xt/client/utils/messageModalQueue/types'
import lodash from 'lodash'
import { EnumCouponStatus } from '@xt/client/enums/order'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  data: {
    required: true,
    type: Object as PropType<CouponProps>
  }
},
  setup(__props) {

const props = __props;

const modal = useModal() // hook 在 wrapper 中使用


const innerData = ref(lodash.cloneDeep(props.data))

// 接收
const onReceive = (data: { id: number; youzanDetail: any }) => {
  innerData.value.successList.map(v => {
    if (v.id === data.id) {
      lodash.set(v, 'wenfangMemberHeader', data.youzanDetail.avatar)
      lodash.set(v, 'wenfangMemberNickname', data.youzanDetail.userNickname)
      lodash.set(v, 'wenfangPhoneNum', data.youzanDetail.userPhone)
      lodash.set(v, 'wenfangReceived', true)
    }
    return v
  })
}

// 兑换
const onExchange = (id: number) => {
  innerData.value.successList.map(v => {
    if (v.id === id) {
      lodash.set(v, 'status', EnumCouponStatus.Used)
    }
    return v
  })
}

// 关闭
const onClear = () => {
  modal.resolve({
    status: 'cancel'
  })
  modal.hide()
}

return { __sfc: true,modal, props, innerData, onReceive, onExchange, onClear, OrderCouponGift }
}

})